import React, { ReactElement } from 'react'
import { Header as KTRHeader} from '@ktr/ktr-materialui-react';
import { useIntl } from 'react-intl';
import { languageMessage } from '../../types/language';

interface Props {
    languages:any,
    getLanguageLabel:any,    
    getLanguageValue:any,    
    getLanguageSelected:any,    
    getCurrentLanguage:any,    
    onLangChange(lang: languageMessage):any,
    showLanguageChanger:boolean
}

function Header(props: Props): ReactElement {
    const { formatMessage: f } = useIntl();

    return (
        <KTRHeader
        showLanguageChanger={props.showLanguageChanger}
        languages={props.languages}
        languageHelperText={f({ id:'app.translator.change' })}
        getLanguageLabel={props.getLanguageLabel}
        getLanguageValue={props.getLanguageValue}
        getLanguageSelected={props.getLanguageSelected}
        getCurrentLanguage={props.getCurrentLanguage}
        onLangChange={props.onLangChange}
        hyperlinkLogo="https://otools.ktr.com/clampex"
      />
    )
}

export default Header